module.exports = __webpack_public_path__ + "static/media/benefit_one.e3578718.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-flight/landing/benefits/benefit_one.png
// module id = 1442
// module chunks = 0